var exports = {
  "Qs": "RecipientList.module__content___OTlab0",
  "Rt": "RecipientList.module__searchInput___OTlab0",
  "qc": "RecipientList.module__searchIcon___OTlab0",
  "qI": "RecipientList.module__listContainer___OTlab0",
  "XG": "RecipientList.module__scroller___OTlab0",
  "wV": "RecipientList.module__noResults___OTlab0",
  "PR": "RecipientList.module__friendList___OTlab0",
  "eH": "RecipientList.module__friendItem___OTlab0",
  "j8": "RecipientList.module__friendItemLeft___OTlab0",
  "Hb": "RecipientList.module__friendInfo___OTlab0",
  "G3": "RecipientList.module__friendName___OTlab0",
  "hw": "RecipientList.module__friendSecondary___OTlab0",
  "hP": "RecipientList.module__actionButton___OTlab0",
};

module.exports = exports;
